
import com.soywiz.korge.view.Image
import com.soywiz.korim.color.RGBA
import game.CgaColor
import game.CgaFont

class Glyph(
    var char: Int,
    var fgColor: RGBA = CgaColor.LIGHT_GRAY.rgba,
    var bgColor: RGBA = CgaColor.BLACK.rgba,
) {}
